/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type ContentStackCampaign } from '../../interface';
import { YMMEModal } from '@/features/ymme/components/YMMEModal';
import { saveUIState } from '@/stores/actions';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { useAppState } from '@/stores/AppState';
import DeviceWrapper from '@/components/AZCustomComponent/DeviceWrapper';
import { useMemo } from 'react';

type Props = {
  content: ContentStackCampaign[];
};

export function CMSCampaignModal({ content }: Props) {
  const router = useLegacyRouter();
  const { query = {} } = router;
  const { cmpid: queryStringCampaignId } = query;

  const { state, dispatch } = useAppState();
  const { campaignModalEnabled } = state;

  const selectedCampaign = useMemo(() => {
    // Require cmpid in route and campaign_id in CS entry to match and defined
    if (!queryStringCampaignId) {
      return null;
    }
    return content.find(
      (campaign) => campaign?.campaign_id && campaign.campaign_id === queryStringCampaignId,
    );
  }, [content, queryStringCampaignId]);
  const shouldDisplayCampaign = selectedCampaign != null && campaignModalEnabled;

  const closeYmmeWidget = () => {
    dispatch(saveUIState({ campaignModalEnabled: false }));
  };

  return (
    <DeviceWrapper mobile desktop={false} tablet={false}>
      <YMMEModal
        showYmme={shouldDisplayCampaign}
        closeYmmeWidget={closeYmmeWidget}
        onUpdateVehicleSuccess={closeYmmeWidget}
        pageType={'campaign'}
        bannerImage={selectedCampaign?.image?.image_url}
        bannerAltText={selectedCampaign?.image?.image_alt_text}
        ymmeCaptionText={selectedCampaign?.caption_text}
        ctaButtonText={selectedCampaign?.cta_button_text}
        campaignFlow
      />
    </DeviceWrapper>
  );
}
